import React from 'react'
import ContactSection from '../../components/contact_us/ContactForm'

const Contact = () => {
  return (
    <div><ContactSection/></div>
  )
}

export default Contact